import { DateTime } from "@/Common/Helpers/DateTime";

class Lab {
    public Id: number;
    public Name: string;
    public Address: string;
    public Fax: string;
    public Phone: string;
    public Country: string;
    public Province: string;
    public City: string;
    public RegionNumber: string;
    public Identification: string;
    public PhonePublic: string;
    public FaxPublic: string;
    public ContactPersonName: string;
    public SearchableSummary1: string;
    public SearchableSummary2: string;
    public Email: string;
    public Note: string;
    public PostalCode: string;
    public AddedByEmployeeContactId: string;
    public CreationDate: string;
    public IsApproved: DateTime;

    // Not in DB
    public IsHighlighted: boolean;

    constructor() {
        this.Id;
        this.Name = "";
        this.Address = "";
        this.Fax = "";
        this.Phone = "";
        this.Country = "";
        this.Province = "";
        this.City = "";
        this.RegionNumber = "";
        this.Identification = "";
        this.PhonePublic = "";
        this.FaxPublic = "";
        this.ContactPersonName = "";
        this.SearchableSummary1 = "";
        this.SearchableSummary2 = "";
        this.Email = "";
        this.Note = "";
        this.PostalCode = "";
        this.AddedByEmployeeContactId = "";
        this.CreationDate = "";
        this.IsApproved = null;
    }
}

export { Lab };
